import TwoColumnData from "./TwoColumnData";
import SingleColumnData from "./SingleColumnData";
const BoxContent = ({data})  => {

    const panels = [];

    // Loop through the data to check for consecutive items with '50' width
    for (let i = 0; i < data.length; i++) {
      const currentItem = data[i];
      const nextItem = data[i + 1];
  
      // Use a switch statement to handle different cases
      switch (currentItem.cc_box_content_width) {
        case '50':
          if (nextItem && nextItem.cc_box_content_width === '50') {
            // If both current and next item have width '50', group them together
            panels.push(
              <div key={`panel-group-${i}`} className="process-panels-container tram-hts-container-two-col">
                <TwoColumnData key={i} item={currentItem} />
                <TwoColumnData key={i + 1} item={nextItem} />
              </div>
            );
            i++; // Skip the next item since it's already grouped with the current one
          } else {
            // If it's a single '50' width item, render it alone
            panels.push(
              <div className="process-panels-container tram-hts-container-two-col">
                <TwoColumnData key={i} item={currentItem} />
              </div>
            );
          }
          break;
  
        default:
          // For non-'50' width items, render them using SingleColumnData
          panels.push(
            <SingleColumnData key={i} item={currentItem} />
          );
          break;
      }
    }

    return(
        <div className="processes box-content text-center p-bottom-100 p-top-70">
          <div className="container">
            {panels}
          </div>
        </div>
            
    );
}

export default BoxContent;

